import type { JSX } from 'preact';
import type { Components } from '../types';

const LABELS: Array<[keyof Components, string, boolean]> = [
  ['protein', 'P', false],
  ['grain', 'G', false],
  ['veggie', 'V', true],
  ['fruit', 'F', false],
  ['fat', 'Fat', false],
];

const baseStyle = (isVeggie: boolean): JSX.CSSProperties => ({
  background: isVeggie ? 'var(--accent-mint-bg)' : 'var(--surface-card)',
  color: isVeggie ? 'var(--accent-mint-ink)' : 'var(--ink)',
  fontSize: '10px',
  padding: '2px 7px',
  borderRadius: '4px',
  fontWeight: 600,
  marginRight: '3px',
});

export function ComponentPills(props: { components: Components; hiddenVeggie?: boolean }) {
  return (
    <span>
      {LABELS.map(([key, label, isVeg]) =>
        props.components[key] ? (
          <span key={key} style={baseStyle(isVeg)}>
            {isVeg && props.hiddenVeggie ? `+${label} hidden` : label}
          </span>
        ) : null
      )}
    </span>
  );
}
